import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e789c75")

_pushScopeId("data-v-0e789c75")
const _hoisted_1 = { class: "site-preview-shell" }
const _hoisted_2 = { class: "site-preview-toolbar" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to editor ")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-muted small" }, "Draft preview", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-muted p-5 text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-danger m-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: `/sites/${_ctx.siteId}/edit`,
        class: "btn btn-sm btn-light"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_4,
      (_ctx.previewUrl)
        ? (_openBlock(), _createBlock("a", {
            key: 0,
            href: _ctx.previewUrl,
            class: "btn btn-sm btn-light ms-auto",
            target: "_blank",
            rel: "noopener"
          }, " Open in new tab ", 8, ["href"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_5, "Loading preview..."))
      : (_ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
        : (_ctx.previewHtml)
          ? (_openBlock(), _createBlock("iframe", {
              key: _ctx.previewKey,
              class: "site-preview-frame",
              srcdoc: _ctx.previewHtml,
              title: "Site preview"
            }, null, 8, ["srcdoc"]))
          : _createCommentVNode("", true)
  ]))
})